import posthog from "posthog-js";
import { shouldInitializePostHogClient, getPostHogClientInitOptions } from "./lib/posthog-config";

if (typeof window !== "undefined") {
  const path = window.location.pathname;
  if (shouldInitializePostHogClient(path)) {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim();
    if (key) {
      try {
        posthog.init(key, getPostHogClientInitOptions());
      } catch {
        // Analytics must never block rendering or auth flows.
      }
    }
  }
}
